import React from 'react'

import styles from './printBarCode.module.scss'
import { useSocPublicImageBucketUrl } from 'src/hooks/useSocPublicImageBucketUrl'

interface PrintBarCodeProps {
  size?: number
  style?: React.CSSProperties
  width?: string
  height?: string
}

const PrintBarCode: React.FC<PrintBarCodeProps> = props => {
  const { size, style, width, height } = props
  const barcodeImage = useSocPublicImageBucketUrl('print-barcode')
  return (
    <div
      className={styles.barCode}
      style={style ?? (size ? { width: size } : {})}
    >
      <img
        src={barcodeImage}
        alt=""
        style={{
          height: height ?? '26.67px',
          width: width ?? '26.67px',
          border: '2px solid white',
          marginBottom: '13.33px',
        }}
      />
    </div>
  )
}

export default PrintBarCode
